import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'
import { TgtLogger } from '@measurement/opentelemetry-web'

export const IndirectItemRequests = () => {
  return (
    <MicroFrontEnd
      name="IndirectItemRequests"
      src={apiConfig.microFrontEnds.IndirectItemRequests}
      useErrorBoundary
      logger={TgtLogger}
    />
  )
}

export default IndirectItemRequests
